export default function VisibilityIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="visibility-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M24 31.5q3.55 0 6.025-2.475Q32.5 26.55 32.5 23q0-3.55-2.475-6.025Q27.55 14.5 24 14.5q-3.55 0-6.025 2.475Q15.5 19.45 15.5 23q0 3.55 2.475 6.025Q20.45 31.5 24 31.5Zm0-3.35q-2.15 0-3.65-1.5T18.85 23q0-2.15 1.5-3.65t3.65-1.5q2.15 0 3.65 1.5t1.5 3.65q0 2.15-1.5 3.65T24 28.15Zm0 10.5q-7.05 0-12.85-3.875T2.1 24.65q-.15-.35-.25-.775-.1-.425-.1-.875t.1-.9q.1-.45.25-.75 3.25-6.25 9.05-10.125Q16.95 7.35 24 7.35t12.85 3.875q5.8 3.875 9.05 10.125.15.3.25.75t.1.9q0 .45-.1.875t-.25.775q-3.25 6.25-9.05 10.125Q31.05 38.65 24 38.65ZM24 23Zm0 12q6.05 0 11.1-3.275T42.8 23q-2.65-5.45-7.7-8.725Q30.05 11 24 11t-11.1 3.275Q7.85 17.55 5.15 23q2.7 5.45 7.75 8.725Q17.95 35 24 35Z"
      />
    </svg>
  );
}
